export const UI_updateHorizantalProgressReducer = {
  UI_updateHorizantalProgress: (state, action) => {
    const {
      showHorizontalProgressBar = true,
      horizontalProgressBarProgress = 0,
    } = action.payload;
    state.showHorizontalProgressBar = showHorizontalProgressBar;
    state.horizontalProgressBarProgress = horizontalProgressBarProgress;
  },
};
